// Centralised path helpers for entity detail pages.

export function actorDetailPath(name: string): string {
  return `/actors/${encodeURIComponent(name)}`;
}

export function familyDetailPath(name: string): string {
  return `/families/${encodeURIComponent(name)}`;
}

export function techniqueDetailPath(attackId: string): string {
  return `/techniques/${encodeURIComponent(attackId)}`;
}

export function iocDetailPath(value: string, type?: string): string {
  const base = `/ioc/${encodeURIComponent(value)}`;
  return type ? `${base}?type=${encodeURIComponent(type)}` : base;
}

export function countryDetailPath(code: string): string {
  return `/country/${encodeURIComponent(code.toUpperCase())}`;
}
